var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 286.023,
    height: 43.368,
    viewBox: "0 0 286.023 43.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-220 -267.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M34.948,43.005,24.118,35.223a1.9,1.9,0,0,0-2.213,0L11.076,43.005a1.866,1.866,0,0,1-1.1.363,1.842,1.842,0,0,1-1.786-2.4l4.159-12.658a1.806,1.806,0,0,0-.673-2.033L.767,18.443a1.823,1.823,0,0,1,1.105-3.3H15.312a1.865,1.865,0,0,0,1.78-1.269l4.139-12.6a1.883,1.883,0,0,1,3.56,0l4.139,12.6a1.865,1.865,0,0,0,1.78,1.269H44.151a1.823,1.823,0,0,1,1.105,3.3L34.349,26.281a1.806,1.806,0,0,0-.673,2.033l4.159,12.658a1.842,1.842,0,0,1-1.786,2.4A1.866,1.866,0,0,1,34.948,43.005Z",
    transform: "translate(220 267.257)",
    fill: "#288428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon-2",
    "data-name": "Icon",
    d: "M34.948,43.005,24.118,35.223a1.9,1.9,0,0,0-2.213,0L11.076,43.005a1.866,1.866,0,0,1-1.1.363,1.842,1.842,0,0,1-1.786-2.4l4.159-12.658a1.806,1.806,0,0,0-.673-2.033L.767,18.443a1.823,1.823,0,0,1,1.105-3.3H15.312a1.865,1.865,0,0,0,1.78-1.269l4.139-12.6a1.883,1.883,0,0,1,3.56,0l4.139,12.6a1.865,1.865,0,0,0,1.78,1.269H44.151a1.823,1.823,0,0,1,1.105,3.3L34.349,26.281a1.806,1.806,0,0,0-.673,2.033l4.159,12.658a1.842,1.842,0,0,1-1.786,2.4A1.866,1.866,0,0,1,34.948,43.005Z",
    transform: "translate(280 267.257)",
    fill: "#288428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon-3",
    "data-name": "Icon",
    d: "M34.948,43.005,24.118,35.223a1.9,1.9,0,0,0-2.213,0L11.076,43.005a1.866,1.866,0,0,1-1.1.363,1.842,1.842,0,0,1-1.786-2.4l4.159-12.658a1.806,1.806,0,0,0-.673-2.033L.767,18.443a1.823,1.823,0,0,1,1.105-3.3H15.312a1.865,1.865,0,0,0,1.78-1.269l4.139-12.6a1.883,1.883,0,0,1,3.56,0l4.139,12.6a1.865,1.865,0,0,0,1.78,1.269H44.151a1.823,1.823,0,0,1,1.105,3.3L34.349,26.281a1.806,1.806,0,0,0-.673,2.033l4.159,12.658a1.842,1.842,0,0,1-1.786,2.4A1.866,1.866,0,0,1,34.948,43.005Z",
    transform: "translate(340 267.257)",
    fill: "#288428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon-4",
    "data-name": "Icon",
    d: "M34.948,43.005,24.118,35.223a1.9,1.9,0,0,0-2.213,0L11.076,43.005a1.866,1.866,0,0,1-1.1.363,1.842,1.842,0,0,1-1.786-2.4l4.159-12.658a1.806,1.806,0,0,0-.673-2.033L.767,18.443a1.823,1.823,0,0,1,1.105-3.3H15.312a1.865,1.865,0,0,0,1.78-1.269l4.139-12.6a1.883,1.883,0,0,1,3.56,0l4.139,12.6a1.865,1.865,0,0,0,1.78,1.269H44.151a1.823,1.823,0,0,1,1.105,3.3L34.349,26.281a1.806,1.806,0,0,0-.673,2.033l4.159,12.658a1.842,1.842,0,0,1-1.786,2.4A1.866,1.866,0,0,1,34.948,43.005Z",
    transform: "translate(400 267.257)",
    fill: "#288428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon-5",
    "data-name": "Icon",
    d: "M34.948,43.005,24.118,35.223a1.9,1.9,0,0,0-2.213,0L11.076,43.005a1.866,1.866,0,0,1-1.1.363,1.842,1.842,0,0,1-1.786-2.4l4.159-12.658a1.806,1.806,0,0,0-.673-2.033L.767,18.443a1.823,1.823,0,0,1,1.105-3.3H15.312a1.865,1.865,0,0,0,1.78-1.269l4.139-12.6a1.883,1.883,0,0,1,3.56,0l4.139,12.6a1.865,1.865,0,0,0,1.78,1.269H44.151a1.823,1.823,0,0,1,1.105,3.3L34.349,26.281a1.806,1.806,0,0,0-.673,2.033l4.159,12.658a1.842,1.842,0,0,1-1.786,2.4A1.866,1.866,0,0,1,34.948,43.005Z",
    transform: "translate(460 267.257)",
    fill: "#288428"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars5);
export default __webpack_public_path__ + "static/media/stars-5.24968329663f0ce6f57ee3cbb062f7b8.svg";
export { ForwardRef as ReactComponent };